import { proxy } from 'valtio'

export const listNodeUploadProgressStore = proxy<Record<string, { completed: number; total: number } | null>>({})

export function setListNodeUploadProgress(nodeId: string, progress: { completed: number; total: number } | null) {
  listNodeUploadProgressStore[nodeId] = progress
}
